import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface HoursToPlanHoverHeaderProps {
  hoursToPlan: number
}

export const HoursToPlanHoverHeader = ({ hoursToPlan }: HoursToPlanHoverHeaderProps) => {
  return (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Text size="200" weight="bold">
        {i18n.t('project_management.planning.header_cells_hover.hours_to_plan')}
      </Text>
      <Text size="200" weight="bold">
        {hoursToPlan} {i18n.t('project_management.planning.employee_info.hours_unit')}
      </Text>
    </Box>
  )
}

interface HoursToPlanHoverFooterProps {
  agreementHours: number
  hoursOff: number
}

export const HoursToPlanHoverFooter = ({
  agreementHours,
  hoursOff,
}: HoursToPlanHoverFooterProps) => {
  return (
    <Box gap="s4">
      <Box flexDirection="row" justifyContent="spaceBetween" paddingBottom={'s4'}>
        <Text size="100" weight="bold">
          {i18n.t('project_management.planning.header_cells_hover.agreement_hours')}
        </Text>
        <Text size="100" weight="bold">
          {agreementHours} {i18n.t('project_management.planning.employee_info.hours_unit')}
        </Text>
      </Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text size="100">{i18n.t('project_management.planning.header_cells_hover.time_off')}</Text>
        <Text size="100">
          {`-${hoursOff} ${i18n.t('project_management.planning.employee_info.hours_unit')}`}
        </Text>
      </Box>
    </Box>
  )
}
